import { inject } from '@angular/core';
import {
  CreateReportCommand,
  HealthRecordsService,
  ReportType,
  SpeciesDto,
} from '@anihis/core/data-access';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { TranslocoService } from '@jsverse/transloco';
import { LoadingStatus } from '../../../../shared/enums/loading';
import { finalize } from 'rxjs';

type FormState = {
  data: SpeciesDto[] | undefined;
  status: LoadingStatus | undefined;
};

const initialState: FormState = {
  data: undefined,
  status: undefined,
};

export const FormStore = signalStore(
  withState(initialState),
  withMethods(
    (
      store,
      healthRecordsService = inject(HealthRecordsService),
      translocoService = inject(TranslocoService),
    ) => {
      return {
        saveForm(data: string, animalUid: string, reportType?: ReportType) {
          const command: CreateReportCommand = {
            jsonContent: data,
            animalUid: animalUid,
            reportType: reportType,
            language: translocoService.getActiveLang(),
          };
          patchState(store, { status: LoadingStatus.Loading });

          return healthRecordsService
            .healthRecordsReportsPost(command)
            .pipe(
              finalize(() =>
                patchState(store, { status: LoadingStatus.Loaded }),
              ),
            );
        },
      };
    },
  ),
);
